import { appRoutes } from "@/app/router";
import { clientEnvModule } from "@/modules/client-env";
import { buildAppWindowUrl } from "@/modules/window/build-url";

export const getWindowOutlookCalendarOAuthRedirectUrl = () => {
  const isDesktop = clientEnvModule.isDesktop();

  if (isDesktop) {
    return buildAppWindowUrl({
      path: appRoutes.integrationsOutlookCalendarCallback({}).path,
    }).toString();
  }

  return buildAppWindowUrl({
    path: appRoutes.integrationsOutlookCalendarCallback({}).path,
  }).toString();
};
